// @module TavanoTeam.CapSciExtensions.CSSearchSpringExt
define('TavanoTeam.CapSciExtensions.CSSearchSpringExt.Footer'
,	[
		'Footer.View'
	,	'Profile.Model'

	,	'SC.Configuration'

	,	'tavanoteam_capsciextension_cssearchspringext_footer.tpl'

	,	'underscore'
	,	'jQuery'
	]
,   function (
		FooterView
	,	ProfileModel

	,	Configuration

	,	tavanoteam_capsciextension_cssearchspringext_footer_tpl

	,	_
	,	jQuery
	)
{
	'use strict';

	return  {
		loadSearchSpringFooter: function loadSearchSpringFooter (container)
		{
			_.extend(FooterView.prototype, {
				template: tavanoteam_capsciextension_cssearchspringext_footer_tpl
			,	initialize: _.wrap(FooterView.prototype.initialize, function(fn, options)
				{
					var origInit = fn.apply(this, _.toArray(arguments).slice(1));

					return origInit;
				})
			,	getContext: _.wrap(FooterView.prototype.getContext, function(fn)
				{
					var origCtx = fn.apply(this, _.toArray(arguments).slice(1))
					,	profileModel = ProfileModel.getInstance();

					origCtx['searchSpringURL'] = '//'+Configuration.get('searchSpring.url');
					origCtx['level1'] = profileModel.get('isLoggedIn') == 'T' ? true : false;

					return origCtx;
				})
			});
		}
	};
});
